export const titles = {
    personal: {
        titulo: 'Personal'
    },
    configuracion: {
        titulo: 'Configuración',
        options: {
            compania: 'Compañía',
            companiaPublicidad: 'Compañía publicidad',
            clasesGenericas: 'Clases genéricas',
            archivosSistema: 'Archivos del sistema',
            interlocutorComercial: 'Interlocutor comercial',
            sistema: 'Sistema',
            articulos: 'Artículos',
            avisoVencimiento: 'Aviso de vencimiento',
            estructuraCertificado: 'Estructuras de certificados',
            seguimientoDocumentos: 'Seguimiento de documentos',
            dashboard: 'Dashboard',
            columnasFormularios: 'Columnas de formularios',
            configuracionFormulario: 'Configuración de formulario'
        }
    },
    facturacionElectronica: {
        titulo: 'Facturación electrónica'
    },
    administracion: {
        titulo: 'Administración',
        options: {
            usuarios: 'Usuarios',
            grupos: 'Grupos',
            accesosPropiedades: 'Accesos',
            usuariosConectados: 'Usuarios  conectados'
        }
    },
    licencias: {
        titulo: 'Licencias',
        options: {
            licencias: 'Licencias',
        }
    },
    versiones: {
        titulo: 'Versiones'
    },
}
export const titlesComponents = {
    compania: {
        mantenimientoCompania: 'Mantenimiento de compañías',
        nuevaCompania: 'Nueva compañía',
        modificarCompania: {
            datosGenerales: 'Datos generales',
            glosa: 'Glosa',
            factores: 'Factores',
            modulos: 'Módulos',
            configuracionCorreo: 'Config. correo',
            firmaHolografa: 'Firma holográfa',
            bancos: 'Bancos'
        }
    },
    companiaPublicidad: {
        mantenimientoCompaniaPublicidad: 'Mantenimiento de compañías publicidad',
        nuevaPublicidad: 'Nueva publicidad',
        modificarPublicidad: {
            datosGenerales: 'Datos generales',
            adjunto: 'Adjunto'
        }
    },
    clasesGenericas: {
        clasesArticulos: {
            nuevaClaseArticulos: 'Nueva clase de artículos',
            modificarClaseArticulos: 'Modificar clase de artículos',
            mantenimientoCodigo: {
                mantenimientoCodigosArticulo: 'Mantenimiento de códigos - Artículo :',
                nuevoCodigo: 'Nuevo código',
                modificarCodigo: 'Modificar código',
            }
        },
        clasesClientes: {
            nuevaClaseClientes: 'Nueva clase de clientes',
            modificarClaseClientes: 'Modificar clase de clientes',
            mantenimientoCodigo: {
                mantenimientoCodigosInterlocutor: 'Mantenimiento de códigos - Interlocutor :',
                nuevoCodigo: 'Nuevo código',
                modificarCodigo: 'Modificar código',
            }
        },
        clasesTituloLista: {
            nuevaClaseTituloLista: 'Nueva clase de título de lista',
            modificarClaseTituloLista: 'Modificar clase de título de lista',
        },
        clasesDocumentoCobranza: {
            nuevaClaseDocumentoCobranza: 'Nueva clase documento cobranza',
            codigo: {
                nuevoCodigo: 'Nuevo código',
                modificarCodigo: 'Modificar código',
            }
        },
        clasesArticulosAlternativo: {
            nuevaClaseArticulosAlternativo: 'Nueva clase de artículos alternativo',
            modificarClaseArticulosAlternativo: 'Modificar clase de artículos alternativo',
        },
        clasesCabeceraDocumento: {
            nuevaClaseCabeceraDocumento: 'Nueva clase de cabecera documento',
            codigo: {
                nuevoCodigo: 'Nuevo código',
                modificarCodigo: 'Modificar código',
            }
        },
        clasesCabeceraDocumentoRango: {
            nuevaClaseCabeceraDocumentoRango: 'Nueva clase de cabecera documento rango',
            codigo: {
                nuevoCodigo: 'Nuevo código',
                modificarCodigo: 'Modificar código',
            }
        },
        clasesDetallesDocumento: {
            nuevaClaseDetalleDocumento: 'Nueva clase de detalle documento',
            codigo: {
                nuevoCodigo: 'Nuevo código',
                modificarCodigo: 'Modificar código',
            }
        },
    },
    archivoSistema: {
        sucursal: {
            nuevaSucursal: 'Nueva sucursal',
            nuevaClase: 'Nueva clase',
            modificarClase: 'Modificar clase',
        },
        moneda: {
            nuevaMoneda: 'Nueva moneda',
            modificarMoneda: 'Modificar moneda',
        },
        motivo: {
            nuevoMotivo: 'Nuevo motivo',
            nuevaClase: 'Nueva clase',
            modificarClase: 'Modificar clase',
        },
        transportistas: {
            nuevoTransportista: 'Nuevo transportista',
            modificarTransportista: 'Modificar transportista',
        },
        documentosSeries: {
            nuevoDocumento: 'Nuevo documento',
            nuevaSituacion: 'Nueva situación',
            modificarSituacion: 'Modificar situación',
            nuevaClase: 'Nueva clase',
            modificarClase: 'Modificar clase',
        },
        documentosCobranza: {
            nuevoDocumentoCobranza: 'Nuevo documento de cobranza',
            nuevaClase: 'Nueva clase',
            modificarClase: 'Modificar clase',
        },
        vendedores: {
            nuevoVendedor: 'Nuevo vendedor',
        },
        tipoGasto: {
            nuevoTipoGasto: 'Nuevo tipo de gasto',
            modificarTipoGasto: 'Modificar tipo de gasto',
        },
        tipoAnalisis: {
            nuevoTipoAnalisis: 'Nuevo tipo análisis',
            modificarTipoAnalisis: 'Modificar tipo análisis',
        },
        cobradores: {
            nuevoCobrador: 'Nuevo cobrador',
            modificarCobrador: 'Modificar cobrador',
        },
        entidadesFinancieras: {
            nuevaEntidadFinanciera: 'Nueva entidad financiera',
            modificarEntidadFinanciera: 'Modificar entidad financiera',
        },
        lugarEmision: {
            nuevoLugarEmision: 'Nuevo lugar de emisión',
            modificarLugarEmision: 'Modificar lugar de emisión',
        },
        mediosPago: {
            nuevoMedioPago: 'Nuevo medio de pago',
            nuevaClase: 'Nueva clase',
            modificarClase: 'Modificar clase',
            nuevaConfiguracion: 'Nueva configuración',
            modificarConfiguracion: 'Modificar configuración',
        },
        tiposDocumento: {
            nuevoTipoDocumento: 'Nuevo tipo de documento',
            nuevaClase: 'Nueva clase',
            modificarClase: 'Modificar clase',
        },
        conceptoImpositivo: {
            nuevoConceptoImpositivo: 'Nuevo concepto impositivo',
            modificarConceptoImpositivo: 'Modificar concepto impositivo',
        },
        vehiculos: {
            nuevoVehiculo: 'Nuevo vehículo',
            modificarVehiculo: 'Modificar vehículo',
        },
        tfactor: {
            nuevoTfactor: 'Nuevo TFactor',
        },
        referenciaBusqueda: {
            nuevaReferenciaBusqueda: 'Nueva referencia búsqueda',
            modificarReferenciaBusqueda: 'Modificar referencia búsqueda',
        },
        regimenRetenciones: {
            nuevoRegimenRetenciones: 'Nueva régimen retenciones',
            nuevaVigencia: 'Nueva vigencia',
            modificarVigencia: 'Modificar vigencia',
        },
    }

}
export const titlesOptions = {
    configuracion: {
        clasesGenericas: {
            title: 'Clases genéricas',
            mantenimientoDe: 'Mantenimiento de',
            clasesArticulos: {
                title: 'Clases de artículos',
            },
            clasesClientes: {
                title: 'Clases de clientes',
            },
            clasesVendedores: {
                title: 'Clases de vendedores',
            },
            clasesDocumentos: {
                title: 'Clases de documentos',
            },
            clasesPlanCuentas: {
                title: 'Clases de plan de cuentas',
            },
            clasesTituloLista: {
                title: 'Clases de título de lista',
            },
            clasesDocumentoCobranza: {
                title: 'Clases de documento cobranza',
            },
            clasesArticulosAlternativo: {
                title: 'Clases de artículos alternativo',
            },
            clasesCabeceraDocumento: {
                title: 'Clases de cabecera de documento',
            },
            clasesCabeceraDocumentoRango: {
                title: 'Clases de cabecera de documento rango',
            },
            clasesDetallesDocumento: {
                title: 'Clases de detalles de documento',
            },

        },
        archivoSistema: {
            title: 'Config. archivos',
            mantenimientoDe: 'Mantenimiento de',
            sucursal: {
                title: 'Sucursal',
            },
            moneda: {
                title: 'Moneda',
            },
            motivo: {
                title: 'Motivo',
            },
            transportistas: {
                title: 'Transportistas',
            },
            documentosSeries: {
                title: 'Documentos-Series',
            },
            documentosCobranza: {
                title: 'Documentos de cobranza',
            },
            vendedores: {
                title: 'Vendedores',
            },
            tipoGasto: {
                title: 'Tipo de gasto',
            },
            tipoAnalisis: {
                title: 'Tipo de análisis',
            },
            cobradores: {
                title: 'Cobradores',
            },
            entidadesFinancieras: {
                title: 'Entidades financieras',
            },
            lugarEmision: {
                title: 'Lugar de emisión',
            },
            medioPago: {
                title: 'Medios de pago',
            },
            tiposDocumento: {
                title: 'Tipos de documento',
            },
            conceptoImpositivo: {
                title: 'Concepto impositivo',
            },
            vehiculos: {
                title: 'Vehículos',
            },
            tfactor: {
                title: 'TFactor',
            },
            referenciaBusqueda: {
                title: 'Referencia de búsqueda',
            },
            regimenRetenciones: {
                title: 'Régimen retenciones',
            },
        }
    }
}